import React, { useEffect } from "react";
import "./App.css";
import Login from "./components/login/Login";
import { Loading } from "./components/Loading";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import {
  selectAccessAuthorization,
  update,
  updateRoles,
} from "./features/login/loginSlice";
import AppLayout from "./components/layout/AppLayout";
import { Cookies } from "react-cookie";
import { loading, notLoading } from "./features/loading/loadingSlice";
import { getUserRole } from "./api/userApi";

function App() {
  const cookies = new Cookies();
  const rt: string = cookies.get("refreshToken");
  const at: string = cookies.get("accessToken");
  const u: string = cookies.get("user");

  const dispatch = useAppDispatch();

  useEffect(() => {
    const initializeApp = async () => {
      if (rt && at && u) {
        dispatch(loading());
        dispatch(
          update({
            accessToken: at,
            refreshToken: rt,
            user: u,
          })
        );
        const roles = await getUserRole(u, at);
        dispatch(updateRoles(roles));
      }
    };
    dispatch(notLoading());
    initializeApp();
  }, [rt, at, u, dispatch]);

  const logged = useAppSelector(selectAccessAuthorization);

  return (
    <div className="App">
      <Loading />
      {logged === undefined ? <Login /> : <AppLayout />}
    </div>
  );
}

export default App;
